import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { focus } from '../../utils/dom';

export class SearchInput extends Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidUpdate() {
    focus(this._input);
  }

  render() {
    const { handleChange, id, intl, placeholderMessage, value } = this.props;

    return (
      <input id={id}
        name="q"
        type="search"
        placeholder={intl.formatMessage(placeholderMessage)}
        value={value}
        onChange={handleChange}
        ref={ref => this._input = ref}
      />
    );
  }
}

SearchInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholderMessage: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired
};

SearchInput.defaultProps = {
  value: ''
};

export default injectIntl(SearchInput);
